import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BL } from 'src/environments/environment';
import { ConfigService } from '../config/config.service';
import { CrewInfo } from 'src/app/models/CrewInfo';
import { FlightResponse } from 'src/app/flight/models/FlightResponse';
import { NewTicketRequest } from 'src/app/flight/models/NewTicketRequest';
import { NewTicketResponse } from 'src/app/flight/models/NewTicketResponse';
import { ValidateCrewInfo } from 'src/app/models/ValidateCrewInfo';
import { PasseLivreService } from './passe-livre.service';
import { OTAAirScheduleResponse } from 'src/app/flight/models/OTAAirScheduleResponse';

@Injectable({
  providedIn: 'root'
})
export class PasseLivreLatamCrewService extends PasseLivreService {

  constructor(protected http: HttpClient, protected configService: ConfigService) {
    super(http, configService);
  }

  getFlights(dateFlight: string, dateTimeClient: string, origin: string, destination: string): Observable<FlightResponse[]> {
    let params = `dateFlight=${dateFlight}&dateTimeClient=${dateTimeClient}&origin=${origin}&destination=${destination}`;
    return this.http.get<FlightResponse[]>(`${this.API_URL}${BL.getFlights}?${params}`);
  }

  getFlightsWithConex(dateFlight: string, dateTimeClient: string, origin: string, destination: string): Observable<any> {
    const params = `dateFlight=${dateFlight}&dateTimeClient=${dateTimeClient}&origin=${origin}&destination=${destination}`;
    return this.http.get<OTAAirScheduleResponse[]>(`${this.API_URL}${BL.getFlights}?${params}`);
  }

  newTicket(newTicketRequest: NewTicketRequest): Observable<NewTicketResponse> {
    return this.http.post<NewTicketResponse>(`${this.API_URL}${BL.newTicketLatamCrew}`, newTicketRequest);
  }

  getLatamCrew(): Observable<CrewInfo> {
    return this.http.get<CrewInfo>(`${this.API_URL}${BL.getLatamCrew}`);
  }

  validateLatamCrew(): Observable<ValidateCrewInfo> {
    return this.http.get<ValidateCrewInfo>(`${this.API_URL}${BL.validateLatamCrew}`);
  }

  changeBp(object: { to: string }): Observable<any> {
    return this.http.post<any>(`${this.API_URL}${BL.changeBp}`, object);
  }

  getCrewByBpTest(bpTest: string): Observable<any> {
    return this.http.get<any>(`${this.API_URL}${BL.getCrewByBpTest}?bpTest=${bpTest}`);
  }
}
